<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="documentTypes.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="180"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="documentType"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :document-type="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="documentTypes.per_page"
        layout="total, prev, pager, next"
        :total="documentTypes.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'created_at',
          order: 'descending',
        },
      };
    },
    computed: {
      documentTypes() {
        return this.$store.getters['documentType/documentTypes'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['documentType/tableConfig']));
      },
      loading() {
        return this.$store.getters['documentType/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('documentType/setFilterString', '');
      this.$store.commit('documentType/setCurrentPage', this.currentPage);
      this.$store.commit('documentType/setSorting', this.currentSort);
      await this.$store.dispatch('documentType/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('documentType/setCurrentPage', val);
        this.$store.dispatch('documentType/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('documentType/setSorting', { prop, order });
          this.$store.dispatch('documentType/fetchAll');
        }
      },
    },
  };
</script>

